var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 300,
    viewBox: "0 0 1440 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 101.326,
    width: 96.4643,
    height: 96.4643,
    rx: 48.2322,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6443,
    y: 102.97,
    width: 93.1758,
    height: 93.1758,
    rx: 46.5879,
    stroke: "url(#paint0_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28856
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.773,
    y: 101.326,
    width: 96.4643,
    height: 96.4643,
    rx: 48.2322,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.418,
    y: 102.97,
    width: 93.1758,
    height: 93.1758,
    rx: 46.5879,
    stroke: "url(#paint1_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28856
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.695,
    y: 123.25,
    width: 52.6169,
    height: 52.6169,
    rx: 26.3085,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.34,
    y: 124.894,
    width: 49.3284,
    height: 49.3284,
    rx: 24.6642,
    stroke: "url(#paint2_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28856
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.547,
    y: 92.5566,
    width: 114.003,
    height: 114.003,
    rx: 57.0017,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.191,
    y: 94.2009,
    width: 110.715,
    height: 110.715,
    rx: 55.3574,
    stroke: "url(#paint3_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28856
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.242,
    y: 123.25,
    width: 52.6169,
    height: 52.6169,
    rx: 26.3085,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.886,
    y: 124.894,
    width: 49.3284,
    height: 49.3284,
    rx: 24.6642,
    stroke: "url(#paint4_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28856
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1063.96,
    y: 92.5586,
    width: 114,
    height: 114,
    rx: 57,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.6,
    y: 94.2028,
    width: 110.712,
    height: 110.712,
    rx: 55.3558,
    stroke: "url(#paint5_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28846
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1094.65,
    y: 123.25,
    width: 52.6154,
    height: 52.6154,
    rx: 26.3077,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1096.29,
    y: 124.894,
    width: 49.3269,
    height: 49.3269,
    rx: 24.6635,
    stroke: "url(#paint6_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28846
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1204.27,
    y: 101.327,
    width: 96.4615,
    height: 96.4615,
    rx: 48.2308,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1205.91,
    y: 102.971,
    width: 93.1731,
    height: 93.1731,
    rx: 46.5865,
    stroke: "url(#paint7_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28846
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1226.19,
    y: 123.25,
    width: 52.6154,
    height: 52.6154,
    rx: 26.3077,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1227.83,
    y: 124.894,
    width: 49.3269,
    height: 49.3269,
    rx: 24.6635,
    stroke: "url(#paint8_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28846
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ddddddi_784_4620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1327.04,
    y: 101.327,
    width: 96.4615,
    height: 96.4615,
    rx: 48.2308,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.68,
    y: 102.971,
    width: 93.1731,
    height: 93.1731,
    rx: 46.5865,
    stroke: "url(#paint9_linear_784_4620)",
    strokeOpacity: 0.15,
    strokeWidth: 3.28846
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddddi_784_4620",
    x: -10.5008,
    y: 85.9796,
    width: 153.467,
    height: 181.967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0779,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6169
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38474,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.7136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548093
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5008,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0779
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38474,
    dy: 8.76949
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.539
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddddddi_784_4620",
    x: 112.273,
    y: 85.9796,
    width: 153.467,
    height: 181.967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0779,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6169
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38474,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.7136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548093
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5008,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0779
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38474,
    dy: 8.76949
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.539
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddddddi_784_4620",
    x: 134.194,
    y: 107.903,
    width: 109.619,
    height: 138.119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0779,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6169
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38474,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.7136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548093
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5008,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0779
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38474,
    dy: 8.76949
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.539
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddddddi_784_4620",
    x: 235.046,
    y: 77.21,
    width: 171.006,
    height: 199.506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0779,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6169
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38474,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.7136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548093
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5008,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0779
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38474,
    dy: 8.76949
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.539
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddddddi_784_4620",
    x: 265.741,
    y: 107.903,
    width: 109.619,
    height: 138.119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0779,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6169
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76949,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38474,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.7136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548093
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5008,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0779
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38474,
    dy: 8.76949
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.539
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ddddddi_784_4620",
    x: 1035.46,
    y: 77.2124,
    width: 171,
    height: 199.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0769,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38462
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64423
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38462,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.71346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0769
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38462,
    dy: 8.76923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ddddddi_784_4620",
    x: 1066.15,
    y: 107.904,
    width: 109.615,
    height: 138.115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0769,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38462
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64423
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38462,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.71346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0769
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38462,
    dy: 8.76923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ddddddi_784_4620",
    x: 1175.77,
    y: 85.981,
    width: 153.461,
    height: 181.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0769,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38462
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64423
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38462,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.71346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0769
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38462,
    dy: 8.76923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ddddddi_784_4620",
    x: 1197.69,
    y: 107.904,
    width: 109.615,
    height: 138.115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0769,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38462
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64423
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38462,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.71346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0769
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38462,
    dy: 8.76923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ddddddi_784_4620",
    x: 1298.54,
    y: 85.981,
    width: 153.461,
    height: 181.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 35.0769,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.6154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_784_4620",
    result: "effect2_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38462
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_784_4620",
    result: "effect3_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.76923,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64423
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_784_4620",
    result: "effect4_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.38462,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.71346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_784_4620",
    result: "effect5_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 28.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35.0769
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect5_dropShadow_784_4620",
    result: "effect6_dropShadow_784_4620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_784_4620",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38462,
    dy: 8.76923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0 0.992157 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_784_4620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_784_4620",
    x1: 66.2322,
    y1: 101.326,
    x2: 108.196,
    y2: 207.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_784_4620",
    x1: 189.006,
    y1: 101.326,
    x2: 230.97,
    y2: 207.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_784_4620",
    x1: 189.004,
    y1: 123.25,
    x2: 211.893,
    y2: 181.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_784_4620",
    x1: 320.549,
    y1: 92.5566,
    x2: 370.142,
    y2: 217.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_784_4620",
    x1: 320.551,
    y1: 123.25,
    x2: 343.44,
    y2: 181.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_784_4620",
    x1: 1120.96,
    y1: 92.5586,
    x2: 1170.55,
    y2: 217.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_784_4620",
    x1: 1120.96,
    y1: 123.25,
    x2: 1143.84,
    y2: 181.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_784_4620",
    x1: 1252.5,
    y1: 101.327,
    x2: 1294.46,
    y2: 207.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_784_4620",
    x1: 1252.5,
    y1: 123.25,
    x2: 1275.39,
    y2: 181.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_784_4620",
    x1: 1375.27,
    y1: 101.327,
    x2: 1417.23,
    y2: 207.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.0183a1519076fb7b75d182d4a64a97de.svg";
export { ForwardRef as ReactComponent };